import { useMemo } from 'react';
import { plugin, debug } from 'light-component';
import * as Base from '@base';
import { Require } from '../component';
import { useTranslation } from '../../i18n';
import styles from './style.module.less';
import type { WidgetProps } from 'light-component';
import type { Key, ReactElement } from 'react';
import type { GroupOptionItem } from './types';

export interface TreeSelectProps extends WidgetProps {
  title: string;
  value?: string[];
  className?: string;
  require?: boolean;
  placeholder?: string;
  options: GroupOptionItem[];
}

export function WidgetFolderTreeSelect(props: TreeSelectProps): ReactElement {
  debug.widget('dashboard FolderTreeSelect', props);
  const [t] = useTranslation();

  const onChange = (folderIds: string[]): void => {
    props.onChange?.(folderIds.length > 0 ? folderIds : undefined);
  };

  const treeData = useMemo(() => {
    const folders = props.options?.map(item => ({
      id: item._id,
      title: item.name,
      pId: item.parent ?? 'all',
      value: item._id
    }));

    if (folders == null || folders.length === 0) {
      return [];
    }

    const root = {
      pId: '',
      id: 'all',
      title: t('全部文件夹'),
      value: 'all'
    };
    return [root, ...folders];
  }, [props.options, t]);

  // 默认展开第一层级的节点
  const expandKeys: Key[] = [];
  const keys = treeData.filter(data => data.pId === '').map(item => item.id);
  expandKeys.push(...keys);

  return (
    <div className={props.className}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <Base.TreeSelect
        treeDataSimpleMode
        className={styles.treeSelect}
        treeIcon
        value={props.value}
        placeholder={t('请选择文件夹')}
        showSearch
        allowClear
        treeDefaultExpandedKeys={expandKeys}
        autoClearSearchValue
        size='middle'
        treeNodeFilterProp='title'
        treeLine={{ showLeafIcon: false }}
        popupMatchSelectWidth={false}
        treeData={treeData}
        onChange={onChange}
        multiple
        maxTagCount={3}
      />
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'folder-tree', component: WidgetFolderTreeSelect });
